// How the browser tab is written: "<page> — Verso People", or the bare app name when the route names
// nothing. One function, because the rule is the kind that rots quietly — a route that supplies no
// title must not leave the PREVIOUS route's title standing in the tab, and " — " with nothing in
// front of it is a tab that reads like a bug. Both cases are pinned in documentTitle.test.mjs.
//
// The app name is passed in rather than read here: it is `t("app.title")`, so the tab follows the
// language switcher like every other string in the shell.

/** The em-dash separator between the page and the app name. Exported so the test states it once. */
export const TITLE_SEPARATOR = " — ";

/**
 * The document title for a page. A blank/whitespace-only/absent page title collapses to the app
 * name alone — never a stale title, never a dangling separator.
 */
export function formatDocumentTitle(
  pageTitle: string | null | undefined,
  appName: string,
): string {
  const page = pageTitle?.trim() ?? "";
  return page.length > 0 ? `${page}${TITLE_SEPARATOR}${appName}` : appName;
}
